import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import HamburgerMenu from "react-hamburger-menu"

// import material ui
// import Typography from "@material-ui/core/Typography"
// import Grid from "@material-ui/core/Grid"

// import app components
import { fadeIn } from "../Animation"
import MainMenu from "../menu/MainMenu"
// import Edges from "../_layout/edges"
import MobileMenu from "../menu/MobileMenu"

import CircleLogo from "../../../static/logos/circle-logo.svg"

import * as theme from "../../theme"

const Header = ({ path }) => {
  const [menuState, setMenuState] = useState(false)

  useEffect(() => {
    // Whenever 'path' changes, close mobile menu
    setMenuState(false)
  }, [path])

  return (
    <NavBar menuIsOpen={menuState}>
      <LogoLink to="/" onClick={() => setMenuState(false)}>
        <CircleLogo />
      </LogoLink>
      <DesktopMenu path={path} />
      <MobileBtn onClick={() => setMenuState(!menuState)}>
        <HamburgerMenu
          color="black"
          isOpen={menuState}
          width={18}
          height={15}
          strokeWidth={1}
          menuClicked={() => ""}
        />
      </MobileBtn>
      <MobileMenu menuState={menuState} onClick={() => setMenuState(false)} />
    </NavBar>
  )
}

export default Header

const LogoLink = styled(Link)`
  animation: ${fadeIn} 0.6s ease-in-out 0s normal;
`

const DesktopMenu = styled(MainMenu)`
  /* @media (max-width: 799px) {
    display: none;
  } */
`
const MobileBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  cursor: pointer;
  @media screen and (min-width: 800px) {
    display: none;
  }
`
const NavBar = styled.div`
  position: relative;

  ${props =>
    !!props.menuIsOpen &&
    css`
      position: sticky;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 999;
    `}

  @media (min-width: 800px) {
    padding: 15px 40px;
  }
  padding: 10px;
  background: ${theme.color.paper};
  display: flex;
  justify-content: space-between;
  align-items: center;
`
